<div fxLayout="row">
  <div fxFlex="65">
    @if (header) {
      <div>
        FUND RECAP
      </div>
    }
    @if (!header) {
      <div>
        {{ fund.Fund.Code }} - {{ fund.Fund.Description }}
      </div>
    }
  </div>
  <div fxFlex="35" fxLayout="row" fxLayoutAlign="end">
    @if (header) {
      <div>
        AMOUNT
      </div>
    }
    @if (!header) {
      <div>
        {{ fund.TotalAmount | currency }}
      </div>
    }
  </div>
</div>